import 'core-js/fn/array/find'
import 'core-js/es6/promise'

import Vue from 'vue'
import VueCookie from 'vue-cookie'
import WidgetSDK from './sdk'
import WidgetEvents from './events'
import WidgetSession from './session'
import AppVue from '../App.vue'
import Router from '../router'
import Freshchat from './api/freshchat'

import VueI18n from 'vue-i18n'
import messages from '@/lang'

import OpoliGatewaySDK from './gateway-sdk'

class OpoliWidget {

  /**
   * new OpoliWidget()
   * Called as soon as the widget is loaded, only receives bundled configuation
   */
  constructor (config) {
    // console.info('configuration', config)
    this.config = config

    // Update Vue config
    Vue.config.productionTip = false

    // Import plugins
    Vue.use(VueCookie)

    // Import Opoli SDK
    Vue.use(OpoliGatewaySDK, config.Gateway)

    Vue.use(VueI18n)
    let i18n = new VueI18n({
      locale: 'en',
      messages
    })

    // Create the application Vue instance
    this.app = new Vue({
      el: '#app',
      template: '<App :brand="brand.code" :brandId="brand.id" :user="user" :flash="flash" :cards="cards" :leg1="leg1" :leg2="leg2" :backLink="backLink" :credits="credits" />',
      data: {
        config: config,
        brand: this.config.Brands.D2D, // default brand
        user: null,
        flash: { type: 'none', message: '' },
        cards: null,
        leg1: null,
        leg2: null,
        backLink: '#',
        credits: 0
      },
      watch: {
        user: function (val) {
          if (val) {
            this.$emit('refreshCredits', val.token)
          } else {
            this.credits = 0
          }
        }
      },
      i18n,
      router: Router,
      components: { App: AppVue }
    })
  }

  /**
   * .init()
   * Called by the embedder page, to initialize widget with options, such as brand for styling
   * Vue instance, `this.app` is already available at this point
   */
  init (options) {
    let self = this
    // Update to the embedder page's desired brand
    self.setBrand(options.brand)

    // Initialize SDK
    // self.sdk = new WidgetSDK(self.config.Gateway)
    self.sdk = new WidgetSDK(Object.assign(self.config.Gateway, { optimizationHost: self.config.optimizationHost }))

    // Event modules
    WidgetEvents.init(self)

    // Session, Cookies, DeviceID
    self.session = new WidgetSession(self.app)
    self.session.initializeToken()
    let store = self.app.$children[0].$store
    if (options.airportCode) {
      store.commit('reservation/setInitAirportPickup', options.airportCode)
    }
    if (!options.noAuth && self.session.hasAuthenticatedUser()) {
      self.authenticate(self.session.token, function (res) {
        if (res.corporateProfile && res.corporateProfile.id) {
          store.commit('user/setIsCorporate', true)
          store.commit('user/setCorporateData', {
            name: res.corporateProfile.name,
            logo: res.corporateProfile.logoUrl
          })
        }
        setTimeout(function () { self.app.$emit('ready') }, 10)
      })
    } else {
      setTimeout(function () { self.app.$emit('ready') }, 10)
    }
  }

  showLogin () {
    let store = this.app.$children[0].$store
    store.commit('global/setAuthData', {show: true})
  }
  showSignUp () {
    let store = this.app.$children[0].$store
    store.commit('global/setAuthData', {showSignup: true})
  }
  changeTab (x) {
    let store = this.app.$children[0].$store
    store.commit('other/setOtherData', {widgetTab: x})
  }

  /**
   * .on()
   * Let the embedder page access the Vue app's event system
   */
  on (eventName, callback) {
    this.app.$on(eventName, callback)
  }

  /**
   * .go()
   * Let the embedder page change the current page
   */
  go (pageName) {
    let urlParams = []
    let query = window.location.search.substring(1)
    let vars = query.split('&')
    if (vars.length) {
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        urlParams.push(pair[0])
      }
    }
    if (pageName === 'search' && urlParams.indexOf('id') > -1 && urlParams.indexOf('fname') > -1 && urlParams.indexOf('lname') > -1) {
      return
    }
    this.app.$router.push(pageName)
  }

  /**
   * .bid()
   * Let the embedder page update bid information
   */
  bid (legs) {
    this.app.leg1 = legs[0]
    this.app.leg2 = Object.keys(legs[1]).length ? legs[1] : null
  }

  /**
   * .backLink()
   * Sets the link that will be redirected to when user wants to go back to origin site
   */
  backLink (link) {
    this.app.backLink = link
  }

  /**
   * .authenticate()
   * Let the embedder page authenticate an existing user via token
   */
  authenticate (token, callback) {
    let self = this
    // Will only override if no authenticated user or new token is not guest
    if (!this.session.hasAuthenticatedUser() || !this.session.isGuestToken(token)) {
      // Emit event to login via token
      this.app.$emit('loginToken', {
        token: token,
        callback: callback || function () {
          // Freshchat - Set user (LOGIN)
          Freshchat.setuser(self)
        }
      })
    } else {
      callback({ success: true })
    }
  }

  /**
   * .setBrand()
   */
  setBrand (brandId) {
    if (!brandId) return false

    // Update to the embedder page's desired brand
    this.app.brand = Object.values(this.config.Brands).find((v) => {
      return parseInt(brandId, 10) === parseInt(v.id, 10)
    }) || this.app.brand

    let self = this
    let store = self.app.$children[0].$store
    if (!store.state.tracking.homePageTracked) {
      setTimeout(function () {
        self.app.$emit('gaTracking', {
          page: '/home',
          title: 'Home',
          screenName: 'Home'
        })
      }, 500)
      store.commit('tracking/setHomePageTracked', true)
    }
  }

}

export default OpoliWidget



// WEBPACK FOOTER //
// ./src/modules/widget.js